import muiIcons from "../../../components/icons/mui-icons";

export const topTitleCardData = [
  {
    Icon: muiIcons.PersonIcon,
    title: "New Leads",
    count: 205,
  },
  {
    Icon: muiIcons.HandCoinIcon,
    title: "Sales",
    count: 4021,
  },
  {
    Icon: muiIcons.CheckOutIcon,
    title: "Checkout",
    count: 80,
  },
  {
    Icon: muiIcons.MoneyIcon,
    title: "Expense",
    count: 120,
  },
];

export const sideTitleCardData = [
  {
    Icon: muiIcons.DownloadIcon,
    subtitle: "Today's Upload",
    title: "21",
  },
  {
    Icon: muiIcons.PersonIcon,
    subtitle: "New Users",
    title: "53",
  },
  {
    Icon: muiIcons.MoneyIcon,
    subtitle: "Total Sales",
    title: "4031",
  },
  {
    Icon: muiIcons.MoneyIcon,
    subtitle: "Total Earning",
    title: "4031",
  },
  {
    Icon: muiIcons.SettingIcon,
    subtitle: "Today Servicing",
    title: "301",
  },
  {
    Icon: muiIcons.NotificationsIcon,
    subtitle: "Today Notification",
    title: "401",
  },
];

export const userCardData = {
  name: "James Mitchell",
  email: "uilib@gmail.com",
  position: "Front-end Developer",
  photoUrl: "/assets/images/faces/3.jpg",
};

export const bigImageCardData = [
  {
    title: "Card Title",
    subtitle: "Last updated 3 mins ago",
    date: "03.12.2018",
    comment: 12,
    photoUrl: "/assets/images/photo-long-1.jpg",
  },
  {
    title: "Card Title",
    subtitle: "Last updated 3 mins ago",
    date: "09.11.2019",
    comment: 22,
    photoUrl: "/assets/images/photo-long-2.jpg",
  },
];
